module.exports = __webpack_public_path__ + "media/images/spinner/Spinner-1.5s-203px-38e6305df3f893c03fc0c7049d7d546e.gif";